import { filterLocalizedLifeAreas } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { Goal } from 'shared/types/goal';

export const useFilteredLocalizedLifeAreas = (goals: Goal[]) => {
  const user = useUser();
  const lifeAreas = useSortedLocalizedLifeAreas();
  const allGoals = useSortedGoals();
  const showEmptyLifeAreas =
    !!user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas;

  return useMemo(
    () =>
      filterLocalizedLifeAreas(lifeAreas, {
        goals,
        allGoals,
        showEmptyLifeAreas,
      }),
    [goals, allGoals, lifeAreas, showEmptyLifeAreas],
  );
};
